import { Outlet } from 'react-router-dom';
import { RouteTabs } from '@/components/nav/route-tabs';

// Admin layout: tabbed, tab state lives in the URL (/admin = users,
// /admin/apps = app ownership overview).
const AdminPanel = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-lg font-semibold text-foreground">Admin Panel</h1>
      <RouteTabs
        items={[
          { name: 'Users', to: '/admin', end: true },
          { name: 'Apps', to: '/admin/apps' },
          { name: 'States', to: '/admin/states' },
          { name: 'Webhooks', to: '/admin/webhooks' },
        ]}
      />
      <Outlet />
    </div>
  );
};

export default AdminPanel;
